import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Table, Card, Spin, Tag } from "antd";
import { fetchReservationPayment } from "../../../utils/CustomerService/api.js";
import moment from "moment";
import "../../../App.css";

const { Column, ColumnGroup } = Table;
//const { Search } = Input;

function ReservationPayment() {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  //const [searchQuery, setSearchQuery] = useState("");

  const { data: initialData, isLoading: isInitialLoading } = useQuery({
    queryKey: ["reservation", currentPage, pageSize],
    queryFn: () =>
      fetchReservationPayment({
        page: currentPage,
        pageSize,
      }),
    keepPreviousData: true,
  });

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) setPageSize(size);
  };

  //   const handleSearch = (value) => {
  //    // setSearchQuery(value);
  //     setCurrentPage(1); // Reset pagination
  //   };

  const dataSource = useMemo(() => {
    return initialData?.results?.map((customer) => ({
      key: customer.id,
      guestName: `${customer.reservation.user?.userAccount?.first_name} ${
        customer.reservation.user?.userAccount?.last_name || ""
      }`,
      hostName: customer.reservation.house?.postedBy?.userAccount?.first_name || "null",
      reservationID: customer.reservation.id,
      paymentMethod: customer.payment_method,
      sessionID: customer.transaction_id,
      timeStamp: moment(customer.time_Stamp).format("MMM D, YYYY h:mm A"),
      status: customer.status,
      type: customer.type_of_transaction,
    }));
  }, [initialData]);

  return (
    <>
      <div className="p-2 bg-white rounded-lg shadow-md dark:bg-gray-900 text-gray-900 dark:text-white">
        <div className="flex items-center gap-4 mb-6">
          {/* Search Input */}
          {/* <Search
            placeholder="Search by name or property"
            allowClear
            onSearch={handleSearch}
            className="w-1/2"
          /> */}
        </div>

        {isInitialLoading ? (
          <Card>
            <Spin /> Loading ...
          </Card>
        ) : (
          <Table
            dataSource={dataSource}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: initialData?.totalCount || 0,
              onChange: handlePageChange,
              showSizeChanger: true,
              responsive: true,
            }}
            scroll={{ x: true }}
            className="responsive-table"
          >
            <ColumnGroup>
              <Column
                title="Reservation ID"
                key="reservationID"
                dataIndex="reservationID"
              />
              <Column
                title="Guest Name"
                key="guestName"
                dataIndex="guestName"
              />
              <Column title="Host Name" key="hostName" dataIndex="hostName" />
              <Column
                title="Payment Method"
                key="paymentMethod"
                dataIndex="paymentMethod"
              />
              <Column
                title="Session ID"
                key="sessionID"
                dataIndex="sessionID"
              />
              <Column
                title="Time Stamp"
                key="timeStamp"
                dataIndex="timeStamp"
              />
              <Column
                title="Status"
                key="status"
                dataIndex="status"
                render={(status) => (
                  <Tag
                    className={
                      status === "success"
                        ? "bg-green-600 text-white px-2 rounded-md"
                        : "gold"
                    }
                    key={status.toString()}
                  >
                    {status === "success" ? "Completed" : "Pending"}
                  </Tag>
                )}
              />
              <Column title="Type" key="type" dataIndex="type" />
            </ColumnGroup>
          </Table>
        )}
      </div>
    </>
  );
}

export default ReservationPayment;
